import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard,{attrs:{"outlined":"","rounded":""}},[_c(VIcon,{staticClass:"close-icon",on:{"click":_setup.onHandleIconClick}},[_vm._v("mdi-close")]),(_vm.headline)?_c(VCardTitle,{staticClass:"text-subtitle-1"},[_vm._v(_vm._s(_vm.headline))]):_vm._e(),(_vm.text)?_c(VCardText,[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),_c(VCardText,[_vm._t("text")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }